/* eslint-disable */
import React, { useState, useEffect,  useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { useDispatch, useSelector } from 'react-redux'
import { createClient, updateClient } from '../../actions/clientActions'
import { useSnackbar } from 'react-simple-snackbar'


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
    marginLeft: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddClient = ({ setOpen, open, currentId, setCurrentId }) => {
  const location = useLocation()
  const formRef = useRef();
  const [clientData, setClientData] = useState({ name: '', email: '', phone: '', address: '',zip:'', userId: '' })
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  const dispatch = useDispatch()
  let client = useSelector((state) => currentId ? state.clients.clients.find((c) => c.id === currentId) : null)
  
  
  // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()


  useEffect(() => {
    if (client && currentId!==null) {
      setClientData(client)
    }else{
      setClientData({ name: '', email: '', phone: '', address: '', userId: '' })
    }
  }, [client])

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('profile')))
    setClientData({...clientData, userId: user?.result?.id})
  }, [location])


  useEffect(() => {
    var checkId = user?.result?.id
    if (checkId !== undefined) {
      setClientData({ ...clientData, userId: [checkId] })
    } 

  }, [location])


  const handleSubmitClient = (e) => {
    e.preventDefault()
    let errorMessage = "";
    if (clientData.name ==="") errorMessage+="Name is required."
    if (clientData.address ==="") errorMessage+="Address is required."
    if (clientData.city ==="") errorMessage+="City is required."
    if (clientData.state ==="") errorMessage+="State is required."
    if (clientData.zip ==="") errorMessage+="Zip code is required."
    if (clientData.phone ==="") errorMessage+="Phone is required."
    if (errorMessage.length>0){
          openSnackbar(errorMessage);
      return;
    }
    const formData = new FormData(formRef.current);
        for (const key in clientData) {
          formData.append(key, clientData[key]);
        }
        
        formData.append("userId", parseInt(user?.result?.id));
         const aML_ProgramFile = document.getElementById('aML_Program');
         if (aML_ProgramFile.files.length>0)
            formData.append("aML_Program", aML_ProgramFile.files[0]);

         const business_LicenseFile = document.getElementById('business_License');
         if (business_LicenseFile.files.length>0)
         formData.append("business_License", business_LicenseFile.files[0]);
        
         
    if (currentId) {
      dispatch(updateClient(currentId, formData, openSnackbar))
    } else {
      dispatch(createClient(formData, openSnackbar))
    }
   
    clear()
    handleClose()
  }

  const clear = () => {
    setCurrentId(null)
    setClientData({ name: '', email: '', phone: '', address: '', userId: [] })
  }

  const handleClose = () => {
    setOpen(false);
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)"
  }


  return (
    <div>
      <form >
        <Dialog
          onClose={(e, reason) => {
            if (reason !== 'backdropClick') {
              handleClose()
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={open} fullWidth
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{ paddingLeft: '20px', color: 'white' }}>
            {currentId ? 'Edit Customer' : 'Add new customer'}
          </DialogTitle>
          <DialogContent dividers>


          <div className="customInputs">
              <input 
                placeholder="Name" 
                style={inputStyle} 
                name='name' 
                type='text'  
                onChange={(e) => setClientData({...clientData, name: e.target.value})}
                value={clientData.name} 
              />

              <input 
                placeholder="Email" 
                style={inputStyle} 
                name='email' 
                type='text' 
                onChange={(e) => setClientData({...clientData, email: e.target.value})}
                value={clientData.email} 
              />
              <input 
                placeholder="Phone" 
                style={inputStyle} 
                name='phone' 
                type='text'  
                onChange={(e) => setClientData({...clientData, phone: e.target.value})}
                value={clientData.phone} 
              />
              <input 
                placeholder="Address" 
                style={inputStyle} 
                name='address' 
                type='text' 
                onChange={(e) => setClientData({...clientData, address: e.target.value})}
                value={clientData.address} 
              />

              <input
                placeholder="City"
                style={inputStyle}
                name='city'
                type='text'
                onChange={(e) => setClientData({ ...clientData, city: e.target.value })}
                value={clientData.city}
              />

              <input
                placeholder="State"
                style={inputStyle}
                name='state'
                type='text'
                onChange={(e) => setClientData({ ...clientData, state: e.target.value })}
                value={clientData.state}
              />

              <input
                placeholder="Zip"
                style={inputStyle}
                name='Zip'
                type='text'
                onChange={(e) => setClientData({ ...clientData, zip: e.target.value })}
                value={clientData.zip}
              />

               <input
                placeholder="Fax"
                style={inputStyle}
                name='fax'
                type='text'
                onChange={(e) => setClientData({ ...clientData, fax: e.target.value })}
                value={clientData.fax}
              />

              <input
                placeholder="Web Site"
                style={inputStyle}
                name='website'
                type='text'
                onChange={(e) => setClientData({ ...clientData, website: e.target.value })}
                value={clientData.website}
              />
              <input
                placeholder="DBA"
                style={inputStyle}
                name='dba'
                type='text'
                onChange={(e) => setClientData({ ...clientData, dba: e.target.value })}
                value={clientData.dba}
              />
               <input
                 placeholder="Tax ID/ EIN"
                 style={inputStyle}
                 name='taxId'
                 type='text'
                 onChange={(e) => setClientData({ ...clientData, taxId: e.target.value })}
                 value={clientData.taxId}
               />
              <label for="aML_Program" style={inputStyle}>Upload AML Program</label>
               <input
                placeholder="AML Program"
                style={inputStyle}
                name='aML_Program'
                id='aML_Program'
                type='file'

              />
              <a href={global.config.API_URL + clientData.aML_Program_Link} target='_blank'>{clientData.aML_Program_FileNameWithExtension}</a>

              <label for="business_License" style={inputStyle}>Upload Business License</label>
               <input
                placeholder="Business License"
                style={inputStyle}
                name='business_License'
                id='business_License'
                type='file'

              />
              <a href={global.config.API_URL + clientData.business_License_Link} target='_blank'>{clientData.business_License_FileNameWithExtension}</a>
          </div>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmitClient} variant="contained" style={{ marginRight: '25px' }} >
              Save Customer
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
}

export default AddClient